var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chemtracker-module",
    attrs: {
      "id": "containers-by-regulation"
    }
  }, [_c('div', [_c('a', {
    ref: "#",
    attrs: {
      "id": "csv-export-link"
    },
    on: {
      "click": _vm.downloadListingCsv
    }
  }, [_c('b-img', {
    attrs: {
      "src": _vm.raftHelper.getCsvIconPath(),
      "width": "24",
      "height": "24",
      "fluid": "",
      "alt": "CSV Download"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-form', [_c('fieldset', {
    staticClass: "chemtracker-filters chemical-containers-filters"
  }, [_c('b-row', [_c('b-col', [_c('multi-select-filter', {
    attrs: {
      "get-value": _vm.chemicalRegulationList,
      "id": "regulation-fil",
      "label": "Regulations",
      "display-value": "title",
      "store-watch": "getSelectedRegulations",
      "update-method": _vm.updateRegulations,
      "multiple": true,
      "track-by": "key"
    }
  })], 1), _vm._v(" "), _c('b-col', [_c('short-text-filter', {
    staticClass: "chemtracker-container-text-filter",
    attrs: {
      "id": "chem-name-fil",
      "label": "Chemical Name",
      "get-value": _vm.chemNameFilter,
      "update-method": _vm.updateChemNameFilter
    }
  })], 1), _vm._v(" "), _c('b-col', [_c('short-text-filter', {
    staticClass: "chemtracker-container-text-filter",
    attrs: {
      "id": "cas-num-fil",
      "label": "CAS Number",
      "get-value": _vm.casFilter,
      "update-method": _vm.updateCasFilter
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('multi-select-filter', {
    attrs: {
      "get-value": _vm.allBuildings,
      "id": "building-fil",
      "label": "Building",
      "current-set-value": _vm.firstSelectedBuilding,
      "multiple": false,
      "display-value": "title",
      "track-by": "nid"
    },
    on: {
      "update-filter": function (payload) {
        return _vm.updateBuilding(payload.itemsSelected);
      }
    }
  })], 1), _vm._v(" "), _c('b-col', [_c('multi-select-filter', {
    attrs: {
      "get-value": _vm.allSpaces,
      "id": "space-fil",
      "label": "Location (Space)",
      "store-watch": "getSelectedSpacesFilter",
      "update-method": _vm.updateSpaces,
      "display-value": "title",
      "multiple": true,
      "disable": _vm.spaceDisabled,
      "track-by": "drupal_internal__nid"
    }
  })], 1), _vm._v(" "), _c('b-col', [_c('multi-select-filter', {
    attrs: {
      "get-value": _vm.raftUnits.physicalStateOptions(),
      "id": "physical-fil",
      "label": "Physical State",
      "current-set-value": _vm.physicalStates,
      "update-method": _vm.updatePhysicalState,
      "display-value": "label",
      "multiple": true,
      "track-by": "key"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _vm.containers.length > 0 ? _c('div', {
    attrs: {
      "id": "view-pager-total"
    }
  }, [_vm._v("\n    Displaying " + _vm._s(_vm.raftHelper.displayingCurrent(_vm.currentPage, 25)) + " -\n    " + _vm._s(_vm.raftHelper.displayingCurrentTotal(_vm.totalItems, Math.ceil(_vm.containers.length / 25), _vm.currentPage, 25)) + "\n    of "), _c('strong', [_vm._v(_vm._s(_vm.totalItems))]), _vm._v(" results\n  ")]) : _vm._e(), _vm._v(" "), _c('b-table', {
    ref: "table",
    class: {
      'table-pause-scroll': _vm.isBusy
    },
    attrs: {
      "id": "reconciliation-history",
      "striped": "",
      "hover": "",
      "responsive": "",
      "show-empty": "",
      "no-sort-reset": true,
      "busy": _vm.isBusy,
      "fields": _vm.fields,
      "items": _vm.containers
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function () {
        return [_c('div', {
          staticClass: "text-center text-danger my-2"
        }, [_vm.$isB4 ? _c('div', {
          staticClass: "loading-throbber"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1) : _c('div', [_c('img', {
          attrs: {
            "src": "/sites/all/modules/hide_submit/images/squares.gif",
            "alt": "loading"
          }
        })]), _vm._v(" "), _c('strong', [_vm._v("Loading...")])])];
      },
      proxy: true
    }, {
      key: "empty",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "raftjs-empty-text"
        }, [_vm._v("\n        Please select a regulation to see results. If no chemicals are shown\n        for a selected regulation, please adjust search parameters.\n      ")])];
      }
    }, {
      key: "cell(chem_name)",
      fn: function (row) {
        return [_c('b-link', {
          attrs: {
            "href": '/raft/chemdb/chemical/' + row.item.chem_uuid
          }
        }, [_vm._v("\n        " + _vm._s(row.item.chem_name) + "\n      ")])];
      }
    }, {
      key: "cell(group_name)",
      fn: function (row) {
        return [_c('b-link', {
          attrs: {
            "href": '/node/' + row.item.group_nid
          }
        }, [_vm._v("\n        " + _vm._s(row.item.group_name) + "\n      ")])];
      }
    }, {
      key: "cell(space_title)",
      fn: function (row) {
        return [_c('b-link', {
          attrs: {
            "href": '/node/' + row.item.space_nid
          }
        }, [_vm._v("\n        " + _vm._s(row.item.space_title) + "\n      ")])];
      }
    }, {
      key: "cell(container_id)",
      fn: function (row) {
        return [_c('b-link', {
          attrs: {
            "href": '/raft/chemtracker/container/' + row.item.uuid
          }
        }, [_vm._v("\n        " + _vm._s(row.item.container_id) + "\n      ")])];
      }
    }])
  }), _vm._v(" "), _vm.totalItems > _vm.itemsPerPage ? _c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalItems,
      "per-page": _vm.itemsPerPage,
      "aria-controls": "my-table",
      "first-text": "« first",
      "prev-text": "‹ previous",
      "next-text": "next ›",
      "last-text": "last »",
      "align": "center"
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }